import * as React from 'react';

import * as styles from './styles.css';
import { IPageState } from '../../types/page';
import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';
import { Card } from '../Card';
import { Preloader } from '../Preloader';

interface IResultsMobile {
  results: IResultsState;
  page: IPageState;
  removeFavorite(entityId: number): void;
}

export const ResultsMobile: React.FC<IResultsMobile> = ({ results, page, removeFavorite }) => {
  const { status, favoriteEntities, total } = results;

  return (
    <div className={styles['container']}>
      {favoriteEntities.map((favoriteEntity, index) => (
        <Card
          key={'item-' + favoriteEntity.entityId}
          total={total}
          favoriteEntity={favoriteEntity}
          page={page}
          position={index + 1}
          removeFavorite={removeFavorite}
        />
      ))}
      {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
        <div key="preloader" className={styles['preloader']}>
          <Preloader size={64} />
        </div>
      )}
    </div>
  );
};
